import { QueryKey } from '@tanstack/react-query';
import { UploadedDocument } from '@urbanx/agx.agencies.client';
import AgencyService from 'services/agenciesService';

export interface AgencyBranding {
  accentColorOld?: string;
  backgroundTextColor?: string;
  backgroundColor?: string;
  buttonTextColor?: string;
  inboxBackgroundColor?: string;
  inboxBackgroundColorOpacity?: string;
  sidebarBackgroundColor?: string;
  sidebarBackgroundColorOpacity?: string;
  logo?: UploadedDocument;
  emailLogo?: UploadedDocument;

  brandingColours?: DesignSystemColours;
}

// convert this to typescript
export interface DesignSystemColours {
  mainColour: string;
  generatedMainColours: DesignSystemColourVariable[];
  accentColour: string;
  generatedAccentColours: DesignSystemColourVariable[];
}

// convert this to typescript
export interface DesignSystemColourVariable {
  scalePosition: number;
  hexValue: string;
  isBaseColour: boolean;
}

const getBranding = async (
  { queryKey }: { queryKey: QueryKey },
  getAuthToken: () => Promise<string>
): Promise<AgencyBranding | undefined> => {
  const token = await getAuthToken();
  const service = new AgencyService(token);

  const agencyId = queryKey[1] as string;

  const result = await service.agencyService.get('GetBranding', {
    agencyId: agencyId,
  });

  return result.data;
};

export default getBranding;
